import React, { useEffect, useMemo, useState } from 'react';

import API from '../../api/API';
import { chiaveSquadra } from './links';
import StrisciaRecord from '../../components/statistiche/StrisciaRecord';
import TabellaOrdinabile from '../../components/statistiche/TabellaOrdinabile';
import { LinkSquadra } from '../../components/statistiche/Link';
// Breadcrumb, caricamento ed errore hanno già le loro regole nel foglio della sezione.
import './Statistiche.css';
import './Indici.css';

// Le colonne e le funzioni delle card stanno fuori dal componente perché TabellaOrdinabile tiene
// lo stato dell'ordinamento, e ricrearle a ogni render vorrebbe dire ricalcolarlo a ogni tasto
// premuto nel filtro.
const colonne = [
  {
    chiave: 'nome', etichetta: 'Squadra', testo: true,
    valore: (r) => r.nome,
    rende: (r) => <LinkSquadra slug={r.slug} nome={r.nome} />,
  },
  { chiave: 'gruppo', etichetta: 'Gruppo', testo: true, valore: (r) => r.gruppo || '—' },
  { chiave: 'edizioni', etichetta: 'Ed.', etichettaLunga: 'Edizioni', valore: (r) => r.edizioni },
  { chiave: 'partite', etichetta: 'P', etichettaLunga: 'Partite', valore: (r) => r.partite },
  {
    chiave: 'ultima', etichetta: 'Ultima', testo: true,
    valore: (r) => r.ultimaEdizione,
    rende: (r) => (r.ultimaEdizione ? new Date(r.ultimaEdizione).toLocaleDateString('it-IT') : '—'),
  },
];

// La colonna del nome è testuale, e la forma a card scarta le colonne testuali: senza questo
// titolo da telefono il nome della squadra sarebbe testo morto e l'indice non porterebbe da
// nessuna parte proprio dove viene letto di più.
const titoloSquadra = (r) => <LinkSquadra slug={r.slug} nome={r.nome} />;
const sottotitoloSquadra = (r) => r.gruppo || '—';
const badgeSquadra = (r) => `${r.edizioni} ed.`;

/**
 * Le squadre pubbliche sono poche centinaia e arrivano tutte in una risposta: il filtro resta
 * locale, perché una chiamata di rete per ogni tasto premuto costerebbe più del filtro stesso.
 * È il contrario di quello che fa l'indice giocatori, dove le righe sono migliaia.
 */
export default function IndiceSquadre() {
  const [squadre, setSquadre] = useState([]);
  const [filtro, setFiltro] = useState('');
  const [caricando, setCaricando] = useState(true);

  useEffect(() => {
    let vivo = true;
    API.carriera.squadre()
      .then((r) => { if (vivo && r.isSuccess) setSquadre(r.data || []); })
      .catch(() => { /* l'elenco vuoto lo dice già da sé */ })
      .finally(() => { if (vivo) setCaricando(false); });
    return () => { vivo = false; };
  }, []);

  const visibili = useMemo(() => {
    const q = chiaveSquadra(filtro);
    return q ? squadre.filter((s) => chiaveSquadra(s.nome).includes(q)) : squadre;
  }, [squadre, filtro]);

  return (
    <>
      <h1 className="indice-titolo">Squadre</h1>

      <StrisciaRecord tipo="squadre" />

      <input
        type="search"
        className="indice-filtro"
        aria-label="Filtra le squadre"
        placeholder="Filtra per nome"
        value={filtro}
        onChange={(e) => setFiltro(e.target.value)}
      />

      {caricando ? <div className="statistiche-loading">Caricamento…</div> : (
        <TabellaOrdinabile
          colonne={colonne}
          righe={visibili}
          chiaveRiga={(r) => r.slug}
          ordineIniziale={{ campo: 'nome', verso: 'asc' }}
          titoloCard={titoloSquadra}
          sottotitoloCard={sottotitoloSquadra}
          badgeCard={badgeSquadra}
          vuoto="Nessuna squadra corrisponde al filtro"
        />
      )}
    </>
  );
}
